

export default (function () {
  return "";
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/idyll-layouts/dist/es/none/styles.js
// module id = 969
// module chunks = 0